const colorPicker = [
  {
    dis: "none" ,
    coloritem: [
      { color: "#FF6263" },
      { color: "#bf3325" },
      { color: "#e21717" },
      { color: "#bf3312" },
      { color: "#d82f2f" },
      { color: "#ed4d4b" },
      { color: "#ef5354" },
      { color: "#b4161b" },
      { color: "#e7425e" },
      { color: "#e83a59" },
      { color: "#d9345a" },
      { color: "#de4839" }
    ],
  },
  {
    heading: "Filling Blue",
    coloritem: [
      { color: "#1b98f5" },
      { color: "#23c4ed" },
      { color: "#383cc1" },
      { color: "#12b0e8" },
      { color: "#51e1ed" },
      { color: "#207398" },
      { color: "#46b2e0" },
      { color: "#3944f7" },
      { color: "#2827cc" },
      { color: "#5da3fa" },
      { color: "#03203C" },
      { color: "#120e43" }
    ],
  },
  {
    heading: "Filling Green",
    coloritem: [
      { color: "#1FAA59" },
      { color: "#66AD47" },
      { color: "#02B290" },
      { color: "#50DBB4" },
      { color: "#3DBE29" },
      { color: "#4DD637" },
      { color: "#1C8D73" },
      { color: "#66AD47" },
      { color: "#6AC47E" },
      { color: "#22CB5C" },
      { color: "#00D84A" },
      { color: "#6EC72D" }
    ],
  },
  {
    heading: "Filling Yellow",
    coloritem: [
      { color: "#E8BD0D" },
      { color: "#EDBF69" },
      { color: "#F4BE2C" },
      { color: "#EDC126" },
      { color: "#E5D68A" },
      { color: "#DDD101" },
      { color: "#D9D55B" },
      { color: "#F7CD2E" },
      { color: "#AF9D5A" },
      { color: "#F4CE6A" },
      { color: "#A77B06" },
      { color: "#C7C11A" }
    ],
  },
  {
    heading: "Filling Fancy",
    coloritem: [
      { color: "#8D3DAF" },
      { color: "#E07C24" },
      { color: "#758283" },
      { color: "#E03B8B" },
      { color: "#FF6666" },
      { color: "#242B2E" },
      { color: "#03C6C7" },
      { color: "#5A20CB" },
      { color: "#6A1B4D" },
      { color: "#CAD5E2" },
      { color: "#35BDD0" },
      { color: "#0D0D0D" }
    ],
  }
];
export default colorPicker;